// import React, { useState, useEffect } from "react";
// import { FaCircleMinus } from "react-icons/fa6";
// import { FaCirclePlus } from "react-icons/fa6";
// import PageBanner from "../../components/common/PageBanner";
// import BgImage from "../../Assets/Images/Faqs/bgfaq.jpg";
// import axios from "axios";
// import Swal from "sweetalert2";

// const Faqs = () => {
//   const [faqs, setFaqs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [formData, setFormData] = useState({
//     question: "",
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const [bannerData, setBannerData] = useState({});

//   const getBannerData = () => {
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/page-banner/get-banner/faqs`,
//       headers: {},
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         console.log(JSON.stringify(response.data));
//         setBannerData(response.data);
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };

//   useEffect(() => {
//     getBannerData();
//   }, []);

//   useEffect(() => {
//     fetchFaqs();
//   }, []);

//   const fetchFaqs = async () => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/faqs/get-all-faqs`
//       );
//       const result = await response.json();
//       setFaqs(result.data);
//       setLoading(false);
//     } catch (error) {
//       console.error(error);
//       setLoading(false);
//     }
//   };

//   const toggleFaq = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.question.trim()) {
//       Swal.fire({
//         title: "Question Required!",
//         text: "Please enter your question.",
//         icon: "warning",
//       });
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       const payload = JSON.stringify({
//         question: formData.question,
//       });

//       const config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         url: `${process.env.REACT_APP_API_URL}/faq-inquiry/create-inquiry`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: payload,
//       };

//       const response = await axios.request(config);
//       console.log(JSON.stringify(response.data));

//       Swal.fire({
//         title: "Good job!",
//         text: "Your question has been submitted successfully!",
//         icon: "success",
//       });

//       setFormData({ name: "", email: "", number: "", question: "" });
//     } catch (error) {
//       console.log(error);
//       Swal.fire({
//         title: "Error!",
//         text: "Something went wrong. Please try again.",
//         icon: "error",
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Filter FAQs based on search query
//   const filteredFaqs = faqs.filter(
//     (faq) =>
//       faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div className="bg-white">
//       <PageBanner
//         title={bannerData.title}
//         subtitle={bannerData.subtitle}
//         background={BgImage}
//       />
//       <div
//         className="tracking-wide mb-12 font-subheading min-h-screen bg-white overflow-hidden"
//         style={{ color: "#080808" }}
//       >
//         {/* Hero Section */}
//         <div className="relative pt-12 px-4 md:px-8 lg:px-12">
//           <div className="">
//             {/* Header */}
//             <div className="text-center mb-12">
//               <h1
//                 className="font-heading text-3xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-primaryTextColor to-primaryBtnHoverColor bg-clip-text"
//                 style={{
//                   backgroundImage:
//                     "linear-gradient(to right, #080808, #CD1B1B)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   backgroundClip: "text",
//                 }}
//               >
//                 FREQUENTLY ASKED QUESTIONS
//               </h1>
//               <p
//                 className="text-xl md:text-2xl max-w-3xl mx-auto"
//                 style={{ color: "#1E1E1E" }}
//               >
//                 Find Answers or Ask Us Anything
//               </p>
//             </div>

//             {/* Main Content Grid */}
//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
//               <div className="lg:col-span-2">
//                 {/* Search Bar */}
//                 <div className="mb-6">
//                   <div className="relative group">
//                     <div
//                       className="absolute inset-0 rounded-2xl opacity-20 blur-xl transition-opacity duration-300 group-hover:opacity-30"
//                       style={{ backgroundColor: "#050733" }}
//                     ></div>
//                     <div className="relative">
//                       <input
//                         type="text"
//                         placeholder="Search FAQs..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         className="w-full px-6 py-4 text-lg border-2 border-gray-200 rounded-2xl focus:border-2 transition-all duration-200 outline-none"
//                         onFocus={(e) =>
//                           (e.target.style.borderColor = "#050733")
//                         }
//                         onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
//                       />
//                       <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
//                         <svg
//                           className="w-6 h-6"
//                           style={{ color: "#CD1B1B" }}
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                           />
//                         </svg>
//                       </div>
//                     </div>
//                   </div>
//                   {searchQuery && (
//                     <p className="mt-3 text-sm" style={{ color: "#1E1E1E" }}>
//                       Found {filteredFaqs.length} result
//                       {filteredFaqs.length !== 1 ? "s" : ""}
//                     </p>
//                   )}
//                 </div>

//                 {/* FAQs List */}
//                 <div className="space-y-4">
//                   {loading ? (
//                     <>
//                       {[1, 2, 3, 4].map((i) => (
//                         <div
//                           key={i}
//                           className="h-20 rounded-3xl animate-pulse"
//                           style={{ backgroundColor: "#e5e7eb" }}
//                         />
//                       ))}
//                     </>
//                   ) : filteredFaqs.length === 0 ? (
//                     <div className="text-center py-12">
//                       <div
//                         className="w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center"
//                         style={{ backgroundColor: "#f3f4f6" }}
//                       >
//                         <svg
//                           className="w-10 h-10"
//                           style={{ color: "#9ca3af" }}
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
//                           />
//                         </svg>
//                       </div>
//                       <h3
//                         className="text-2xl font-bold mb-2"
//                         style={{ color: "#080808" }}
//                       >
//                         No Results Found
//                       </h3>
//                       <p className="text-lg" style={{ color: "#6b7280" }}>
//                         Try adjusting your search terms or ask us a question
//                       </p>
//                     </div>
//                   ) : (
//                     filteredFaqs.map((faq, index) => (
//                       <div key={faq._id} className="group relative">
//                         <div
//                           className={`relative rounded-3xl p-1 bg-opacity-70 overflow-hidden transition-all duration-500 ${
//                             activeIndex === index
//                               ? "bg-gradient-to-br from-primaryBtnColor to-primaryTextColor"
//                               : "bg-gradient-to-br from-gray-100 to-gray-200"
//                           }`}
//                           style={
//                             activeIndex === index
//                               ? {
//                                   backgroundImage:
//                                     "linear-gradient(to bottom right, #050733, #080808)",
//                                 }
//                               : {}
//                           }
//                         >
//                           {/* Background Pattern */}
//                           <div className="absolute inset-0 opacity-10">
//                             <div
//                               className="absolute inset-0 bg-repeat"
//                               style={{
//                                 backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M0 0h40v40H0V0zm20 20h20v20H20V20zm0-20h20v20H20V0z'/%3E%3C/g%3E%3C/svg%3E")`,
//                               }}
//                             ></div>
//                           </div>

//                           <div className="relative bg-white rounded-2xl overflow-hidden">
//                             <button
//                               onClick={() => toggleFaq(index)}
//                               className="w-full px-6 py-5 text-left flex justify-between items-center transition-all duration-500"
//                               style={{
//                                 backgroundColor:
//                                   activeIndex === index ? "#050733" : "white",
//                                 color:
//                                   activeIndex === index ? "white" : "#080808",
//                               }}
//                             >
//                               <span className="font-bold text-lg md:text-xl pr-4">
//                                 {faq.question}
//                               </span>
//                               {activeIndex === index ? (
//                                 <FaCircleMinus
//                                   size={26}
//                                   className="transition-transform duration-500 rotate-0"
//                                   style={{ color: "white" }}
//                                 />
//                               ) : (
//                                 <FaCirclePlus
//                                   size={26}
//                                   className="transition-transform duration-500 rotate-0 hover:rotate-90"
//                                   style={{ color: "#CD1B1B" }}
//                                 />
//                               )}
//                             </button>
//                             <div
//                               className={`overflow-hidden transition-all duration-700 ease-in-out ${
//                                 activeIndex === index
//                                   ? "max-h-96 opacity-100"
//                                   : "max-h-0 opacity-0"
//                               }`}
//                               style={{
//                                 transitionProperty: "max-height, opacity",
//                               }}
//                             >
//                               <div
//                                 className="px-6 py-5 border-t text-lg leading-relaxed"
//                                 style={{ color: "#1E1E1E" }}
//                               >
//                                 {faq.answer}
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                   )}
//                 </div>
//               </div>

//               {/* Right Side - Contact Form (1 column) */}
//               <div className="lg:sticky lg:top-8 h-fit bg-opacity-10">
//                 <div className="group relative">
//                   <div
//                     className="relative rounded-3xl p-1 overflow-hidden"
//                     style={{
//                       backgroundImage:
//                         "linear-gradient(to bottom right, #050733, #080808)",
//                     }}
//                   >
//                     {/* Background Pattern */}
//                     <div className="absolute inset-0 opacity-10">
//                       <div
//                         className="absolute inset-0 bg-repeat"
//                         style={{
//                           backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M0 0h40v40H0V0zm20 20h20v20H20V20zm0-20h20v20H20V0z'/%3E%3C/g%3E%3C/svg%3E")`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative bg-white rounded-3xl overflow-hidden p-6">
//                       <div className="flex items-center mb-6">
//                         <div
//                           className="w-16 h-16 rounded-2xl flex items-center justify-center mr-4"
//                           style={{
//                             backgroundImage:
//                               "linear-gradient(to bottom right, #050733, #CD1B1B)",
//                           }}
//                         >
//                           <span className="text-3xl">❓</span>
//                         </div>
//                         <div>
//                           <h2
//                             className="text-2xl lg:text-3xl font-bold font-heading"
//                             style={{ color: "#080808" }}
//                           >
//                             ASK A QUESTION
//                           </h2>
//                           <div
//                             className="w-20 h-1 rounded-full mt-2"
//                             style={{ backgroundColor: "#CD1B1B" }}
//                           ></div>
//                         </div>
//                       </div>

//                       <p
//                         className="mb-6 text-lg leading-relaxed"
//                         style={{ color: "#1E1E1E" }}
//                       >
//                         Can't find what you're looking for? Send us your
//                         question .
//                       </p>

//                       <div className="space-y-5">
//                         <div>
//                           <label
//                             htmlFor="question"
//                             className="block text-sm font-bold mb-2"
//                             style={{ color: "#080808" }}
//                           >
//                             Your Question{" "}
//                             <span style={{ color: "#CD1B1B" }}>*</span>
//                           </label>
//                           <textarea
//                             id="question"
//                             name="question"
//                             value={formData.question}
//                             onChange={handleInputChange}
//                             rows="5"
//                             className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-2 transition-all duration-200 outline-none resize-none"
//                             onFocus={(e) =>
//                               (e.target.style.borderColor = "#050733")
//                             }
//                             onBlur={(e) =>
//                               (e.target.style.borderColor = "#e5e7eb")
//                             }
//                             placeholder="Type your question here..."
//                           />
//                         </div>

//                         <button
//                           type="button"
//                           onClick={handleSubmit}
//                           disabled={isSubmitting}
//                           className="w-full py-4 rounded-xl font-heading font-bold text-white transition-all duration-300 shadow-lg relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed"
//                           style={{ backgroundColor: "#050733" }}
//                           onMouseEnter={(e) =>
//                             !isSubmitting &&
//                             (e.target.style.backgroundColor = "#CD1B1B")
//                           }
//                           onMouseLeave={(e) =>
//                             (e.target.style.backgroundColor = "#050733")
//                           }
//                         >
//                           <span className="relative z-10 text-lg">
//                             {isSubmitting ? "SUBMITTING..." : "SUBMIT QUESTION"}
//                           </span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Faqs;

import React, { useState, useEffect } from "react";
import { FaCircleMinus } from "react-icons/fa6";
import { FaCirclePlus } from "react-icons/fa6";
import PageBanner from "../../components/common/PageBanner";
import BgImage from "../../Assets/Images/Faqs/bgfaq.jpg";
import axios from "axios";
import Swal from "sweetalert2";

const Faqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [bannerloading, setBannerLoanding] = useState(false);
  const [formData, setFormData] = useState({
    question: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [bannerData, setBannerData] = useState({});

  const getBannerData = () => {
    setBannerLoanding(true);
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/page-banner/get-banner/faqs`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setBannerData(response.data);
        setBannerLoanding(false);
      })
      .catch((error) => {
        console.log(error);
        setBannerLoanding(false);
      });
  };

  useEffect(() => {
    getBannerData();
  }, []);

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/faqs/get-all-faqs`
      );
      const result = await response.json();
      setFaqs(result.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.question.trim()) {
      Swal.fire({
        title: "Question Required!",
        text: "Please enter your question.",
        icon: "warning",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = JSON.stringify({
        question: formData.question,
      });

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/faq-inquiry/create-inquiry`,
        headers: {
          "Content-Type": "application/json",
        },
        data: payload,
      };

      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));

      Swal.fire({
        title: "Good job!",
        text: "Your question has been submitted successfully!",
        icon: "success",
      });

      setFormData({ name: "", email: "", number: "", question: "" });
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Filter FAQs based on search query and exclude return policy
  const filteredFaqs = faqs
    .filter(
      (faq) =>
        !faq.question?.toLowerCase().includes("return policy") &&
        !faq.answer?.toLowerCase().includes("return policy")
    )
    .filter(
      (faq) =>
        faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <div className="bg-white">
      {bannerloading ? (
        <BannerSkeleton />
      ) : (
        <PageBanner
          title={
            bannerData.title
              ? bannerData.title.toUpperCase() === "FAQS"
                ? "FAQ"
                : bannerData.title
              : "FAQ"
          }
          subtitle={bannerData.subtitle}
          background={bannerData.bgImage}
        />
      )}
      <div className="tracking-wide mb-12 font-subheading min-h-screen bg-white text-primaryTextColor overflow-hidden">
        {/* Hero Section */}
        <div className="relative pt-12 px-4 md:px-8 lg:px-12">
          <div className="">
            {/* Header */}
            <div className="text-center mb-12">
              <h1
                className="font-heading text-3xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-primaryTextColor to-primaryBtnHoverColor bg-clip-text"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, #080808, #CD1B1B)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                FREQUENTLY ASKED QUESTIONS
              </h1>
              <p
                className="text-xl md:text-2xl max-w-3xl mx-auto"
                style={{ color: "#1E1E1E" }}
              >
                Find Answers or Ask Us Anything
              </p>
            </div>

            {/* Main Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
              {/* Left Side - FAQs (2 columns) */}
              <div className="lg:col-span-2">
                {/* Search Bar */}
                <div className="mb-6">
                  <div className="relative group">
                    <div
                      className="absolute inset-0 rounded-2xl blur-lg opacity-20 group-hover:opacity-30 transition-opacity duration-300"
                      style={{ backgroundColor: "#050733" }}
                    ></div>
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Search FAQs..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full px-6 py-4 text-lg border-2 border-gray-200 rounded-2xl bg-white bg-opacity-80 backdrop-blur-sm focus:border-2 transition-all duration-200 outline-none"
                        onFocus={(e) =>
                          (e.target.style.borderColor = "#050733")
                        }
                        onBlur={(e) => (e.target.style.borderColor = "#e5e7eb")}
                      />
                      <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                        <svg
                          className="w-6 h-6"
                          style={{ color: "#CD1B1B" }}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  {searchQuery && (
                    <p className="mt-3 text-sm" style={{ color: "#1E1E1E" }}>
                      Found {filteredFaqs.length} result
                      {filteredFaqs.length !== 1 ? "s" : ""}
                    </p>
                  )}
                </div>

                {/* FAQs List */}
                <div className="space-y-4">
                  {loading ? (
                    <>
                      {[1, 2, 3, 4].map((i) => (
                        <div
                          key={i}
                          className="h-20 rounded-3xl animate-pulse"
                          style={{ backgroundColor: "#e5e7eb" }}
                        />
                      ))}
                    </>
                  ) : filteredFaqs.length === 0 ? (
                    <div className="text-center py-12">
                      <div className="w-20 h-20 mx-auto mb-4 rounded-full flex items-center justify-center bg-gray-100 bg-opacity-50 backdrop-blur-sm">
                        <svg
                          className="w-10 h-10"
                          style={{ color: "#9ca3af" }}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          />
                        </svg>
                      </div>
                      <h3
                        className="text-2xl font-bold mb-2"
                        style={{ color: "#080808" }}
                      >
                        No Results Found
                      </h3>
                      <p className="text-lg" style={{ color: "#6b7280" }}>
                        Try adjusting your search terms or ask us a question
                      </p>
                    </div>
                  ) : (
                    filteredFaqs.map((faq, index) => (
                      <div key={faq._id} className="group relative">
                        <div
                          className={`relative rounded-3xl p-1 overflow-hidden transition-all duration-500 ${
                            activeIndex === index
                              ? "bg-opacity-70"
                              : "bg-opacity-50"
                          }`}
                          style={
                            activeIndex === index
                              ? {
                                  backgroundImage:
                                    "linear-gradient(to bottom right, #050733, #080808)",
                                }
                              : {
                                  backgroundImage:
                                    "linear-gradient(to bottom right, #f3f4f6, #e5e7eb)",
                                }
                          }
                        >
                          {/* Background Pattern */}
                          <div className="absolute inset-0 opacity-10">
                            <div
                              className="absolute inset-0 bg-repeat"
                              style={{
                                backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M0 0h40v40H0V0zm20 20h20v20H20V20zm0-20h20v20H20V0z'/%3E%3C/g%3E%3C/svg%3E")`,
                              }}
                            ></div>
                          </div>

                          {/* Glow Effect */}
                          {activeIndex === index && (
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-red-600/20 rounded-3xl blur-lg opacity-25 group-hover:opacity-50 transition duration-300"></div>
                          )}

                          <div className="relative bg-white bg-opacity-95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-lg">
                            <button
                              onClick={() => toggleFaq(index)}
                              className="w-full px-6 py-5 text-left flex justify-between items-center transition-all duration-500"
                              style={{
                                backgroundColor:
                                  activeIndex === index
                                    ? "#050733"
                                    : "rgba(255, 255, 255, 0.8)",
                                color:
                                  activeIndex === index ? "white" : "#080808",
                              }}
                            >
                              <span className="font-bold text-lg md:text-xl pr-4">
                                {faq.question}
                              </span>
                              {activeIndex === index ? (
                                <FaCircleMinus
                                  size={26}
                                  className="transition-transform duration-500 rotate-0"
                                  style={{ color: "white" }}
                                />
                              ) : (
                                <FaCirclePlus
                                  size={26}
                                  className="transition-transform duration-500 rotate-0 hover:rotate-90"
                                  style={{ color: "#CD1B1B" }}
                                />
                              )}
                            </button>
                            <div
                              className={`overflow-hidden transition-all duration-700 ease-in-out ${
                                activeIndex === index
                                  ? "max-h-96 opacity-100"
                                  : "max-h-0 opacity-0"
                              }`}
                              style={{
                                transitionProperty: "max-height, opacity",
                              }}
                            >
                              <div
                                className="px-6 py-5 border-t text-lg leading-relaxed bg-white bg-opacity-90"
                                style={{ color: "#1E1E1E" }}
                              >
                                {faq.answer}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>

              {/* Right Side - Contact Form (1 column) */}
              <div className="lg:sticky lg:top-8 h-fit">
                <div className="group relative">
                  {/* Outer Glow Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-600/30 to-purple-600/30 rounded-3xl blur-lg opacity-25 group-hover:opacity-50 transition duration-300"></div>

                  <div
                    className="relative rounded-3xl p-1 overflow-hidden"
                    style={{
                      backgroundImage:
                        "linear-gradient(to bottom right, #050733, #080808)",
                    }}
                  >
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-10">
                      <div
                        className="absolute inset-0 bg-repeat"
                        style={{
                          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.2'%3E%3Cpath d='M0 0h40v40H0V0zm20 20h20v20H20V20zm0-20h20v20H20V0z'/%3E%3C/g%3E%3C/svg%3E")`,
                        }}
                      ></div>
                    </div>

                    <div className="relative bg-white bg-opacity-95 backdrop-blur-sm rounded-3xl overflow-hidden p-6 shadow-2xl">
                      <div className="flex items-center mb-6">
                        <div
                          className="w-16 h-16 rounded-2xl flex items-center justify-center mr-4 shadow-lg"
                          style={{
                            backgroundImage:
                              "linear-gradient(to bottom right, #050733, #CD1B1B)",
                          }}
                        >
                          <span className="text-3xl">❓</span>
                        </div>
                        <div>
                          <h2
                            className="text-2xl lg:text-3xl font-bold font-heading"
                            style={{ color: "#080808" }}
                          >
                            ASK A QUESTION
                          </h2>
                          <div
                            className="w-20 h-1 rounded-full mt-2"
                            style={{ backgroundColor: "#CD1B1B" }}
                          ></div>
                        </div>
                      </div>

                      <p
                        className="mb-6 text-lg leading-relaxed"
                        style={{ color: "#1E1E1E" }}
                      >
                        Can't find what you're looking for? Send us your
                        question.
                      </p>

                      <div className="space-y-5">
                        <div>
                          <label
                            htmlFor="question"
                            className="block text-sm font-bold mb-2"
                            style={{ color: "#080808" }}
                          >
                            Your Question{" "}
                            <span style={{ color: "#CD1B1B" }}>*</span>
                          </label>
                          <textarea
                            id="question"
                            name="question"
                            value={formData.question}
                            onChange={handleInputChange}
                            rows="5"
                            className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl bg-white bg-opacity-80 backdrop-blur-sm focus:border-2 transition-all duration-200 outline-none resize-none"
                            onFocus={(e) =>
                              (e.target.style.borderColor = "#050733")
                            }
                            onBlur={(e) =>
                              (e.target.style.borderColor = "#e5e7eb")
                            }
                            placeholder="Type your question here..."
                          />
                        </div>

                        <button
                          type="button"
                          onClick={handleSubmit}
                          disabled={isSubmitting}
                          className="w-full py-4 rounded-xl font-heading font-bold text-white transition-all duration-300 shadow-lg hover:shadow-2xl relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 active:scale-95"
                          style={{ backgroundColor: "#050733" }}
                          onMouseEnter={(e) =>
                            !isSubmitting &&
                            (e.target.style.backgroundColor = "#CD1B1B")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.backgroundColor = "#050733")
                          }
                        >
                          <span className="relative z-10 text-lg">
                            {isSubmitting ? "SUBMITTING..." : "SUBMIT QUESTION"}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
const BannerSkeleton = () => {
  return (
    <div className="relative w-full h-36 sm:h-52 md:h-60 lg:h-80 px-4 md:px-8 lg:px-12 animate-pulse">
      <div className="absolute inset-0 bg-gray-300/50"></div>

      <div className="relative z-10 flex flex-col justify-center h-full">
        <div className="h-8 w-40 bg-gray-400/60 rounded-md mb-4"></div>
        <div className="h-4 w-64 bg-gray-400/50 rounded-md"></div>
      </div>
    </div>
  );
};
